import { Card, CardHeader, CardContent } from "@repo/ui/components/card";
import { IconVibeCodingBird } from "central-icons/IconVibeCodingBird";

export function NotFoundError(props: { message?: string }) {
  const { message } = props;
  return (
    <Card className="text-center w-full max-w-sm bg-yellow-50 border-yellow-500 border">
      <CardHeader className="border-b-yellow-500 ">
        <h2 className="text-lg flex items-center justify-center gap-2 font-semibold">
          <IconVibeCodingBird size={24} /> Nothing to see here
        </h2>
      </CardHeader>
      <CardContent className="text-muted-foreground">
        <p>We couldn&apos;t find what you were looking for.</p>
        {message && <p>{message}</p>}
      </CardContent>
    </Card>
  );
}
